<template>
  <div class="OddsColumn-styles-odds-column Category-styles-event-details-column">
    <div class="OddsColumn-styles-title">{{ odd.name }}</div>
    <div class="Category-styles-market-container" v-for="selection in sortAByKey(odd.odd, 'order')">
      <selection :selectedOdds="selectedOdds" :odd.sync="selection" :match="match" :market="odd" />
    </div>
  </div>

</template>

<script>
    import Selection from "../../selectionButton";
    export default {
        name: "block",
        props: ['odd', 'match', 'selectedOdds'],
        components: {Selection}
    }
</script>

<style scoped>
.market-name {
    text-align: center;
    padding: 10px;
    border-bottom: 1px solid #ccc;
}
.market-item {
    display: block;
    float: left;
}
.odd-labels {
    max-width: 100% !important;
    float: left !important;
    margin: 0 !important;
    height: 190px;
    overflow: scroll;
}
</style>


// WEBPACK FOOTER //
// src/components/sportsbook/market/template/block.vue